import { Box, Button, Flex, Heading, Image, Link, Text } from '@chakra-ui/react';
import logo from 'assets/images/logo.png';
import { useToken } from 'components/guest/lib';
import { DocumentWithTokenQuery, useDocumentGuestUpdateMutation } from 'generated/graphql';
import { useState } from 'react';
import { useOnCompleted } from '../lib';
import Dropzone from './Dropzone';
import File from './File';

type Document = DocumentWithTokenQuery['documentWithToken'];

function Upload({ document }: { document: Document }) {
  const [file, setFile] = useState<File>();
  const token = useToken();
  const showConfirmationIfComplete = useOnCompleted(document);
  const [updateDocument, { loading }] = useDocumentGuestUpdateMutation();

  const onDrop = (files: FileList | null) => {
    if (files) setFile(files[0]);
  };

  const handleUpload = async () => {
    await updateDocument({ variables: { id: document.id, token, data: { file } } });
    showConfirmationIfComplete();
  };

  return (
    <Flex w="100%" h="100%" direction="column" align="center">
      <Image src={logo} alt="LM logo" boxSize="80px" />
      <Box textAlign="center" mt={4}>
        <Heading as="h4" size="md">
          {document.name}
        </Heading>
        <Text>
          {document.status === 'completed'
            ? 'Thanks for uploading this document!'
            : document.description}
        </Text>
      </Box>
      <Flex flex={1} direction="column" align="center" p={20} w="100%">
        {document.status === 'completed' ? (
          <Button
            as={Link}
            colorScheme="purple"
            href={document.fileUrl!}
            isExternal
            _hover={{ textDecoration: 'none' }}
          >
            Download {document.name}
          </Button>
        ) : (
          <>
            <Dropzone onDrop={onDrop} />
            <File file={file} />
            <Button
              colorScheme="purple"
              mt={10}
              disabled={!file || loading}
              isLoading={loading}
              onClick={handleUpload}
            >
              Upload
            </Button>
          </>
        )}
      </Flex>
    </Flex>
  );
}

export default Upload;
